import { Button, Flex, Text } from '@mantine/core';
import { closeModal, openModal } from '@mantine/modals';
import { ModalWarningContent, MODAL_SIZE_MEDIUM } from '@shared/ui/modal';
import { useUpdateActivityCompany, type Company } from '@entities/company';
import { useParams } from 'react-router';
import { showNotification } from '@shared/utils';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '@shared/config';

const MODAL_ID = 'company-confirm-deactivate';

const CompanyConfirmDeactivateComponent = () => {
  const { id } = useParams();
  const queryClient = useQueryClient();

  const { mutate: updateActivityCompany, isPending } = useUpdateActivityCompany(
    id || ''
  );

  const handleClose = () => {
    closeModal(MODAL_ID);
  };

  const handleDeactivateCompany = () => {
    updateActivityCompany(
      { isActive: false },
      {
        onSuccess: data => {
          queryClient.setQueryData(
            [QueryKey.GET_COMPANY, id?.toString()],
            (company: Company) => ({ ...company, ...data })
          );

          handleClose();
        },
        onError: error => {
          showNotification({
            error,
            variant: 'error',
            message:
              error.response?.data.message ||
              'Не удалось деактивировать компанию',
          });
        },
      }
    );
  };

  return (
    <Flex>
      <Flex direction='column'>
        <ModalWarningContent
          message={
            <Text c='primary.7'>
              Деактивация компании приведет к
              <Text span fw={600}>
                {' '}
                деактивации всех вакансий и сотрудников{' '}
              </Text>
              компании. Все равно хотите деактивировать компанию?
            </Text>
          }
          iconAlign='flex-start'
        />
        <Flex pt={12} gap={8}>
          <Button variant='outline' onClick={handleClose}>
            Отмена
          </Button>
          <Button
            variant='primary'
            loading={isPending}
            disabled={isPending}
            onClick={handleDeactivateCompany}
          >
            Да, деактивировать
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export const useCompanyConfirmDeactivate = () => {
  const openCompanyConfirmDeactivate = () =>
    openModal({
      modalId: MODAL_ID,
      title: 'Деактивировать компанию',
      size: MODAL_SIZE_MEDIUM,
      children: <CompanyConfirmDeactivateComponent />,
    });

  return { openCompanyConfirmDeactivate };
};
